<template>
<div class="qr-card">
    <div class="qr-container">
        <div class="qr-item">
            <img class="qr-img" :src="qrImages[randomIndex]" :alt="$t('cpts.qrcard.qr')"/>
        </div>
    </div>
    <p class="qr-text">{{ $t("cpts.qrcard.action") }}</p>
</div>
</template>

<script>
export default {
    name: 'QrCard',
    data() {
        return {
            randomIndex: Math.floor(Math.random() * 2),
            qrImages: [
                require('@/assets/index/img/index/cs_0.png'),
                require('@/assets/index/img/index/cs_3.png')
            ]
        }
    }
};
</script>

<style scoped>
.qr-card {
    width: 238px;
    padding: 16px 16px 4px 16px;
    background: #ffffff;
    border-radius: 12px;
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);
    text-align: center;
    user-select: none;
}

.qr-container {
    display: flex;
    justify-content: center;
    gap: 16px;
}

.qr-item {
    flex: 1;
}

.qr-img {
    width: 206px;
    height: 206px;
    object-fit: contain;
    display: block;
    margin: 0 auto;
}

.qr-text {
    margin-top: 4px;
    font-size: 14px;
    color: #555;
}
</style>